//@ts-nocheck

import React from 'react'

import { Heading, Paragraph } from '../../../atoms/Typography/Typography.component'
import { Row, Col, SpacerBase } from '../../../atoms/GridSystem'
import Button from '../../../atoms/Button/Button.component'
import ItemsGrouped from '../../../molecules/ItemsGrouped/ItemsGrouped.component'
import Icon from '../../../atoms/Icon/Icon.component'

import * as S from '../Text.styles'

interface TextHeadingBigProps {
  sectionTitle?: {
    as: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
    typo: string
    content: string
  }
  subtitle?: {
    as: 'p'
    typo: string
    content: string
  }
  alignment?: 'left' | 'center'
  twoColumns?: boolean
  ctaPrimary?: {
    label: string
    [key: string]: any
  }
  ctaSecondary?: {
    label: string
    [key: string]: any
  }
}

const TextHeadingBig: React.FC<TextHeadingBigProps> = ({ preTitle, sectionTitle, subtitle, alignment, twoColumns, ctaPrimary, ctaSecondary }) => {
  return (
    <>
      <Row>
        <Col xs={12} xl={6}>
          <S.TextLeafWrapper>
            <Icon name="leaf-green" useIconColor unlockedProportions />
          </S.TextLeafWrapper>
          <SpacerBase xs={1} />
          {preTitle ? <Paragraph {...preTitle} /> : null}
          <SpacerBase xs={1} />
        </Col>
      </Row>
      <S.RowTextHeading alignment={alignment}>
        <Col
          xs={12}
          lg={twoColumns ? 6 : 10}
          $direction="column"
          $offset={{ xs: 0, lg: twoColumns ? 0 : 1 }}
        >
          {sectionTitle ? (
            <>
              <Heading as={sectionTitle.as} typo={sectionTitle.typo} weight={'medium'}>
                {sectionTitle.content}
              </Heading>
              <SpacerBase xs={1} />
            </>
          ) : null}
        </Col>
        <Col
          xs={12}
          md={10}
          // lg={twoColumns ? 5 : 6}
          lg={5}
          $direction="column"
          $offsetRight={{ lg: 1}}
          // $offset={{ xs: 0, md: twoColumns ? 2 : 1, lg: twoColumns ? 1 : 3 }}
        >
          {subtitle ? <Paragraph {...subtitle} /> : null}
          {ctaPrimary || ctaSecondary ? (
            <>
              <SpacerBase xs={4} lg={0} />
              <ItemsGrouped direction={{ xs: "column", md: "row" }} space={{ xs: 16, md: 24 }} fullWidth={['xs', 'sm']}>
                {ctaPrimary ? <Button {...ctaPrimary} variant="primary" iconEnd="arrow-right" /> : null}
                {ctaSecondary ? <Button {...ctaSecondary} variant="secondary" iconEnd="arrow-right" /> : null}
              </ItemsGrouped>
            </>
          ) : null}
        </Col>
      </S.RowTextHeading>
    </>
  )
}

export default TextHeadingBig
